module.exports = __webpack_public_path__ + "media/icons/plyny-menu@2x-3f517d34.png";